export function GlassBox({ children }: { children: React.ReactNode }) {
  return (
    <div className="glassyBoxBackground  w-full  p-6 flex flex-col gap-6 rounded-lg">
      {children}
    </div>
  )
}
